export default "__VITE_ASSET__Bi8Kr6oE__"